













import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Tab from "@/components/App/Modules/GMS/Dashboard/components/Tabs.vue";
import AppReviewLayoutComponent from '@/components/App/Modules/GMS/Reviewer.External/Dashboard/ExternalReviewerDashboard.vue';

@Component({
  components: { Tab, AppReviewLayoutComponent },
})

export default class ReviewTabsComponent extends Vue {
  tabItems: any = [
    { component: "AppReviewLayoutComponent", text: "Proposals", entity: "Application" },
    { component: "AppReviewLayoutComponent", text: "Concept Notes", entity: "ConceptNote" }
  ];

  activeTabComponent: string = this.tabItems[1].component;
  entity: string = this.tabItems[0].entity;
  key: number = 0;

  items: any = [];
  filters: any = [];

  mounted() {
    // this.getFilter();
    // this.getData(this.activeTabComponent);
  }

  loadComponent(tab) {
    this.items = [];
    this.activeTabComponent = tab.component;
    this.entity = tab.entity;
    this.key += 1;
    // this.getFilter();
    // this.getData(this.activeTabComponent);
  }

  getData(action, filter = "") {
    this.$services.dashboard
      .getInternalDashboard(this.activeTabComponent, filter)
      .then((resp: any) => {
        this.items = resp.data;
      });
  }

  getFilter() {
    this.$services.dashboard
      .getDashboardFilter("Internal", this.activeTabComponent)
      .then((resp: any) => {
        this.filters = resp.data;
      });
  }

  onSearch(filter) {
    this.getData(this.activeTabComponent, filter);
  }
}
